import React, { useEffect, useState } from 'react';
import axios from 'axios';

type DataItem = {
  titular: string;
  error: string;
};

type InclusaoErrosProps = {
  formData?: any;
};

export default function InclusaoErros({
  formData,
}: InclusaoErrosProps): JSX.Element {
  let message = '';
  const resultadoUnificado = formData?.responses.reduce(
    (acc, item) => {
      acc.data.push(...(item.data ?? []));
      acc.sucessos.push(...(item.RetornoApis?.sucessos ?? []));
      acc.erros.push(...(item.RetornoApis?.erros ?? []));
      acc.total += item.RetornoApis?.total ?? 0;
      acc.processados += item.RetornoApis?.processados ?? 0;
      return acc;
    },
    { data: [], sucessos: [], erros: [], total: 0, processados: 0, tipo: '' },
  );
  console.log('resultadoUnificado: ', formData);
  useEffect(() => {
    if (resultadoUnificado?.length > 0) {
      message =
        formData?.responses.find(x =>
          x.RetornoApis.find(x => x.erro.length > 0),
        ).RetornoApis?.message ||
        formData?.responses[0]?.message ||
        formData?.responses[0]?.RetornoApis[0]?.message;
    }
    console.log('message: ', message);
  }, [resultadoUnificado]);

  if (!formData) return;

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-green-600 mb-4">{message}</h2>
      {resultadoUnificado.data && resultadoUnificado.data.length > 0 && (
        <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
          <thead className="bg-gray-200">
            <tr>
              <th className="p-2 text-left">Titular</th>
              <th className="p-2 text-left">Erro S4e</th>
            </tr>
          </thead>
          <tbody>
            {resultadoUnificado.data.map((item, index) => (
              <tr key={index} className="border-b hover:bg-gray-50">
                <td className="p-2 font-medium">{item.titular}</td>
                <td className="p-2 text-red-600">{item.error}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {resultadoUnificado.erros && resultadoUnificado.erros.length > 0 && (
        <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
          <thead className="bg-gray-200">
            <tr>
              <th className="p-2 text-left">Titular</th>
              <th className="p-2 text-left">Cpf</th>
              <th className="p-2 text-left">
                Erro {resultadoUnificado.RetornoApis?.tipo}
              </th>
            </tr>
          </thead>
          <tbody>
            {resultadoUnificado.erros.map((item, index) => (
              <tr key={index} className="border-b hover:bg-gray-50">
                <td className="p-2 font-medium">{item.titular}</td>
                <td className="p-2 font-medium">{item.cpf}</td>
                <td className="p-2 text-red-600">
                  {item.error ||
                    item.resultados.find(res => res.tipo === 'titular')
                      ?.resultado?.Result ||
                    'Erro desconhecido'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
